export default "__VITE_ASSET__8ca63c52__"